
//we have two vendor libs with the same namespace, this routes function calls to the correct one depending on the argument signature
module.exports = function($) {
  require('js/sw-jquery/vendor/jquery.caret.min')($);

  $.fn.caretForTagEditorJs = $.fn.caret;

  require('js/sw-jquery/vendor/jquery.ichord.caret')($);

  $.fn.caretForAtJs = $.fn.caret;

  var isInt = /^\-?\d*$/;

  $.fn.caret = function(method) {
    if (!arguments.length || typeof method === 'number' || (typeof method === 'string' &&  isInt.test(method))) {
      return $.fn.caretForTagEditorJs.apply(this, arguments);
    } else {
      return $.fn.caretForAtJs.apply(this, arguments);
    }
  };
};

